export default (function (obj) {
  return [Object, Array].includes((obj || {}).constructor) && !Object.entries(obj || {}).length;
});
//# sourceMappingURL=isEmpty.js.map